import { Card } from "@/components/ui/card";

export default function Stat({ label, value, icon: Icon, accent }) {
    return (
        <Card className={`p-4 ${accent ? "bg-coral/5 dark:bg-coral/10 border-coral/20" : "bg-card"}`}>
            <div className="flex items-center gap-2 mb-1.5">
                <Icon className={`h-3.5 w-3.5 ${accent ? "text-coral" : "text-muted-foreground"}`} />
                <span className="font-app text-[10px] uppercase tracking-wider text-muted-foreground">{label}</span>
            </div>
            <div className={`font-display text-2xl font-bold tabular-nums ${accent ? "text-coral" : "text-foreground"}`}>
                {value}
            </div>
        </Card>
    );
}
